<template>
  <div class="content_block_container">
    <b-row class="content_block_topbar">
      <b-col cols="6"><h5 class="title_content_block">{{recap_property.title}}</h5></b-col>
      <b-col style="text-align: right">
        <b-button
          class="controller_button_content"
          @click="$emit('shiftUpBlock', index)"
          ><b-icon icon="caret-left-fill" aria-hidden="true"></b-icon
        ></b-button>
        <b-button
          class="controller_button_content"
          @click="$emit('shiftDownBlock', index)"
          ><b-icon icon="caret-right-fill" aria-hidden="true"></b-icon
        ></b-button>
        <b-button
          class="controller_button_content"
          @click="$emit('deleteBlock', index)"
          ><b-icon icon="trash-fill" aria-hidden="true"></b-icon
        ></b-button>
      </b-col>
    </b-row>
    <b-container class="form_button_content">
      <b-row>
        <b-col sm="12">
          <b-form-input
            v-model="recap_property.title"
            placeholder="Titre"
          ></b-form-input>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="12">
          <b-form-input
            v-model="recap_property.value"
            placeholder="Valeur"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="9">
          <b-form-input
            v-model="recap_property.icon"
            placeholder="Icon"
          ></b-form-input>
          <a  style="color:black;font-size:0.8rem;" href="https://fontawesome.com/v5.15/icons?d=gallery&p=2&s=solid&m=free" target="_blank">Liste des icons</a>
        </b-col>
        <b-col cols="3"
          ><p class="align_center" style="margin-top:8px;">
            <v-icon
            scale="2"
              v-if="recap_property.icon"
              :name="recap_property.icon"
            ></v-icon></p
        ></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  props: ["recap_property","index"],
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
</style>